<div class="frames" *ngIf="event != null">
  <!-- Main Event Card -->
  <div class="report-card" id="event__{{ event.id }}">
    <!-- Header: title + amount -->
    <div class="report-card-header" style="border-bottom: none; padding-bottom: 0;">
      <div style="flex: 1;">
        <div style="display: flex; align-items: center; gap: 6px; flex-wrap: wrap;">
          <span class="report-card-name" style="font-size: 1.05rem;">
            {{ event.isBoarding ? (event.animals.length > 0 ? event.animals[0].getName() : '') : event.getTreatmentName(translate) }}
          </span>
          <ion-chip *ngIf="event.amount(comptaService) > 0" color="success" style="height: 24px; font-size: 0.75rem; --padding-start: 6px; --padding-end: 8px;">
            {{ event.amount(comptaService) | currency:'EUR':'symbol':'1.2-2':'fr-FR' }}
          </ion-chip>
        </div>
        <!-- Treatment status inline -->
        <ng-container *ngIf="event.type?.isTreatment">
          <span *ngIf="event.statut?.id == 'done' && !event.treatmentIsSuccess"
            class="report-tag report-tag--danger" style="margin-top: 6px; display: inline-flex;">{{ 'The treatment failed.' | translate }}</span>
          <span *ngIf="event.statut?.id == 'done' && event.treatmentIsSuccess"
            class="report-tag report-tag--success" style="margin-top: 6px; display: inline-flex;">{{ 'The treatment was successful.' | translate }}</span>
          <span *ngIf="event.statut?.id == 'validated' && event.dateTimeStartIsPast(dateUtils)"
            class="report-tag report-tag--warning" style="margin-top: 6px; display: inline-flex;">{{ 'Treatment in progress.' | translate }}</span>
        </ng-container>
      </div>
    </div>

    <!-- Date -->
    <div class="event-fiche-date-row">
      <ion-icon name="time-outline" class="report-section-icon" style="font-size: 0.9rem;"></ion-icon>
      <span>{{ dateUtils.datefusion_full(dateUtils.fromString(event.dateTimeStart), dateUtils.fromString(event.dateTimeEnd)) }}</span>
      <ion-button fill="clear" size="small" (click)="addToCalendar($event)" style="--padding-start: 4px; height: 1.4em; font-size: 0.85em; margin: 0;">
        <ion-icon name="calendar-outline" slot="icon-only"></ion-icon>
      </ion-button>
    </div>

    <!-- Vet / Practitioner -->
    <div *ngIf="event.veterinarian || event.practitioner" class="event-fiche-info-row">
      <ion-icon name="medkit-outline" class="report-section-icon" style="font-size: 0.9rem;"></ion-icon>
      <span>{{ (event.veterinarian || event.practitioner)?.clinic?.name }}{{ (event.veterinarian || event.practitioner)?.name && (event.veterinarian || event.practitioner)?.clinic?.name && (event.veterinarian || event.practitioner)?.name?.toLowerCase() !== (event.veterinarian || event.practitioner)?.clinic?.name?.toLowerCase() ? ' - ' + (event.veterinarian || event.practitioner)?.name : '' }}</span>
    </div>

    <!-- Comment -->
    <div *ngIf="event.comment && event.comment.length > 0" class="event-fiche-comment">
      <p>{{ event.comment }}</p>
      <div *ngIf="event.documents && event.documents.length > 0" class="report-card-documents" style="padding-top: 4px;">
        <ion-icon name="document-attach-outline" class="report-section-icon"></ion-icon>
        <span *ngFor="let d of event.documents; let index = index">
          <span *ngIf="index > 0">, </span><span class="action fileLink"
            (click)="setModalDisplayDocumentDocument(d);modalDisplayDocument.present()">{{ d.name }}</span>
        </span>
      </div>
    </div>

    <!-- Status tags + Animal chips -->
    <div class="report-card-tags" style="padding-top: 10px;">
      <span class="report-tag report-tag--danger" *ngIf="(event.statut?.id ?? 'canceled') == 'canceled'">{{ 'Canceled' | translate }}</span>
      <span class="report-tag report-tag--success" *ngIf="(event.statut?.id ?? 'validated') == 'validated' && !event.type?.isTreatment && !event.isBoarding">
        {{ event.getStatutName(translate, dateUtils) }}
      </span>
      <ng-container *ngIf="event.isBoarding">
        <span class="report-tag" [class.report-tag--success]="event.boardingStatus !== 'CLOSED'" [class.report-tag--danger]="event.boardingStatus === 'CLOSED'">
          <ion-icon [name]="event.boardingStatus === 'CLOSED' ? 'lock-closed-outline' : 'radio-button-on'" style="font-size: 0.8rem;"></ion-icon>
          {{ (event.boardingStatus === 'CLOSED' ? 'Closed' : 'Active') | translate }}
        </span>
        <span *ngIf="!event.boardingInvoiceId" class="report-tag report-tag--warning">
          <ion-icon name="receipt-outline" style="font-size: 0.8rem;"></ion-icon>
          {{ 'No invoice generated yet' | translate }}
        </span>
        <span *ngIf="event.boardingInvoiceId" class="report-tag" style="background: var(--ion-color-step-100); color: var(--ion-color-step-600);">
          <ion-icon name="checkmark-circle-outline" style="font-size: 0.8rem;"></ion-icon>
          {{ 'Invoice' | translate }}
        </span>
      </ng-container>
      <span class="report-tag report-tag--success"
        *ngIf="(event.statut?.id ?? 'validated') == 'validated' && event.type?.isTreatment && event.dateTimeStartIsPast(dateUtils)">{{ 'In progress' | translate }}</span>
      <span class="report-tag report-tag--success"
        *ngIf="(event.statut?.id ?? 'validated') == 'validated' && event.type?.isTreatment && !event.dateTimeStartIsPast(dateUtils)">{{ 'planned' | translate }}</span>
      <span class="report-tag report-tag--danger"
        *ngIf="(event.statut?.id ?? 'tobeconfirmed') == 'tobeconfirmed'">{{ 'To be confirmed' | translate }}</span>
      <span class="report-tag" style="background: var(--ion-color-step-100); color: var(--ion-color-step-600);"
        *ngIf="(event.statut?.id ?? 'done') == 'done'">{{ 'Finished' | translate }}</span>
    </div>

    <!-- Animal chips -->
    <div class="event-fiche-animals" *ngIf="(event.animals?.length ?? 0) > 0">
      <ng-container *ngFor="let animal of event.animals">
        <div class="event-fiche-animal-chip"
          (click)="closeEvent.emit();router.navigate(['animal-fiche/', animal.id]);$event.stopPropagation();">
          <img [src]="animal.avatar ? animal.avatarBase64 : '/assets/icon/animal.png'" class="report-card-avatar" style="width: 28px; height: 28px; border-radius: 8px;">
          <span>{{ animal.getName() }}</span>
        </div>
      </ng-container>
    </div>
  </div>

  <!-- Boarding: owner info (SonEspacePension) or pension org info (other apps) -->
  <div class="report-card" *ngIf="event.isBoarding">
    <ng-container *ngIf="environment.APP_VERSION === 'SonEspacePension' && event.boardingOwner">
      <div class="report-card-header">
        <ion-icon name="person-circle-outline" class="report-section-icon" style="font-size: 1.2rem;"></ion-icon>
        <span class="report-card-name">{{ event.boardingOwner.firstName }} {{ event.boardingOwner.lastName }}</span>
      </div>
      <div *ngIf="event.boardingOwner.addrStreet || event.boardingOwner.addrCity" class="event-fiche-info-row">
        <ion-icon name="location-outline" class="report-section-icon" style="font-size: 0.9rem;"></ion-icon>
        <span>
          <span *ngIf="event.boardingOwner.addrStreet">{{ event.boardingOwner.addrStreet }}, </span>
          <span *ngIf="event.boardingOwner.addrPostalCode">{{ event.boardingOwner.addrPostalCode }} </span>
          <span *ngIf="event.boardingOwner.addrCity">{{ event.boardingOwner.addrCity }}</span>
        </span>
      </div>
      <div *ngIf="event.boardingOwner.phoneNumber" class="event-fiche-info-row">
        <ion-icon name="call-outline" class="report-section-icon" style="font-size: 0.9rem;"></ion-icon>
        <a [href]="'tel:' + event.boardingOwner.phoneNumber" class="event-fiche-link">{{ event.boardingOwner.phoneNumber }}</a>
      </div>
      <div *ngIf="event.boardingOwner.email" class="event-fiche-info-row">
        <ion-icon name="mail-outline" class="report-section-icon" style="font-size: 0.9rem;"></ion-icon>
        <a [href]="'mailto:' + event.boardingOwner.email" class="event-fiche-link">{{ event.boardingOwner.email }}</a>
      </div>
    </ng-container>

    <ng-container *ngIf="environment.APP_VERSION !== 'SonEspacePension' && event.boardingOrg">
      <div class="report-card-header">
        <ion-icon name="business-outline" class="report-section-icon" style="font-size: 1.2rem;"></ion-icon>
        <span class="report-card-name">{{ event.boardingOrg.name }}</span>
      </div>
      <div *ngIf="event.boardingOrg.addrStreet || event.boardingOrg.addrCity" class="event-fiche-info-row">
        <ion-icon name="location-outline" class="report-section-icon" style="font-size: 0.9rem;"></ion-icon>
        <span>
          <span *ngIf="event.boardingOrg.addrStreet">{{ event.boardingOrg.addrStreet }}, </span>
          <span *ngIf="event.boardingOrg.addrPostalCode">{{ event.boardingOrg.addrPostalCode }} </span>
          <span *ngIf="event.boardingOrg.addrCity">{{ event.boardingOrg.addrCity }}</span>
        </span>
      </div>
      <div *ngIf="event.boardingOrg.phoneNumber" class="event-fiche-info-row">
        <ion-icon name="call-outline" class="report-section-icon" style="font-size: 0.9rem;"></ion-icon>
        <a [href]="'tel:' + event.boardingOrg.phoneNumber" class="event-fiche-link">{{ event.boardingOrg.phoneNumber }}</a>
      </div>
      <div *ngIf="event.boardingOrg.email" class="event-fiche-info-row">
        <ion-icon name="mail-outline" class="report-section-icon" style="font-size: 0.9rem;"></ion-icon>
        <a [href]="'mailto:' + event.boardingOrg.email" class="event-fiche-link">{{ event.boardingOrg.email }}</a>
      </div>
    </ng-container>
  </div>

  <ng-container *ngFor="let animal of event.animals">
    @let report = getReportOfAnimal(event, animal);
    <ng-container *ngIf="report">
      <div class="report-card">
        <!-- Header: animal avatar + name + weight -->
        <div class="report-card-header"
          (click)="router.navigate(['animal-fiche/', animal.id]);$event.stopPropagation();">
          <div class="report-card-avatar-wrapper">
            <img [src]="animal.avatar ? animal.avatarBase64 : '/assets/icon/animal.png'" class="report-card-avatar">
          </div>
          <span class="report-card-name">{{ animal.getName() }}</span>
          <ion-chip *ngIf="report?.weight" class="report-card-weight" color="primary">
            <ion-icon name="fitness-outline" style="margin-right: 4px;"></ion-icon>
            {{ report?.weight }} {{ (report.animal?.weightUnit || 'kg') | translate }}
          </ion-chip>
        </div>

        <!-- Tags: diseases, operations, nothing to report -->
        <div class="report-card-tags" *ngIf="(report?.diseases?.length ?? 0) > 0 || (report?.surgicalOperations?.length ?? 0) > 0 || report?.isNothingToReport">
          <ng-container *ngFor="let d of report?.diseases">
            <span class="report-tag report-tag--danger">
              <img src="/assets/icon/disease.png" class="report-tag-icon">{{ d.disease?.name }}
            </span>
          </ng-container>
          <ng-container *ngFor="let d of report?.surgicalOperations">
            <span class="report-tag report-tag--warning">
              <img src="/assets/icon/operation.png" class="report-tag-icon">{{ d.surgicalOperation?.name }}
            </span>
          </ng-container>
          <span *ngIf="report?.isNothingToReport" class="report-tag report-tag--success">
            <img src="/assets/icon/heart.png" class="report-tag-icon" style="border: none;">{{ 'Nothing to report' | translate }}
          </span>
        </div>

        <!-- Vaccines -->
        <div class="report-card-vaccines" *ngIf="report?.vaccines?.length">
          <ion-icon name="shield-checkmark-outline" class="report-section-icon"></ion-icon>
          <span>
            <ng-container *ngFor="let vaccine of report?.vaccines; let index = index">
              <span *ngIf="index > 0">, </span>{{ vaccine.label?.name }}
            </ng-container>
          </span>
        </div>

        <!-- Report text -->
        <div class="report-card-section" *ngIf="!report?.isNothingToReport && report?.report">
          <div class="report-section-title">
            <img src="/assets/icon/info.png" class="report-section-img">{{ 'Report' | translate }}
          </div>
          <p class="report-section-text">{{ report?.report }}</p>
        </div>

        <!-- Treatment -->
        <div class="report-card-section" *ngIf="report?.treatment">
          <div class="report-section-title">
            <img src="/assets/icon/treatment.png" class="report-section-img">{{ 'Treatment' | translate }}
          </div>
          <p class="report-section-text white-space">{{ report?.treatment?.comment }}</p>
        </div>

        <!-- Documents -->
        <div class="report-card-documents" *ngIf="report?.documents?.length">
          <ion-icon name="document-attach-outline" class="report-section-icon"></ion-icon>
          <span *ngFor="let d of report?.documents; let index = index">
            <span *ngIf="index > 0">, </span>
            <span class="action fileLink"
              (click)="setModalDisplayDocumentDocument(d);modalDisplayDocument.present()">{{ d.name }}</span>
          </span>
        </div>
      </div>
    </ng-container>
  </ng-container>
</div>


<ion-modal #modalDisplayDocument>
  <ng-template>
    <ion-header>
      <ion-toolbar>
        <ion-buttons slot="end">
          <ion-button (click)="modalDisplayDocument.dismiss()" [strong]="true">{{ 'Close' | translate }}</ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content padding *ngIf="modalDisplayDocumentDocument != null">
      <ion-item lines="none">
        <ion-label>{{ modalDisplayDocumentDocument['name'] }} </ion-label>
      </ion-item>
      <ion-item lines="none">
        <img src="{{modalDisplayDocumentDocumentBase64}}" style="width: 100%; height: auto;">
      </ion-item>
    </ion-content>
  </ng-template>
</ion-modal>

<ion-modal [isOpen]="isNextOccurrenceModalOpen" (didDismiss)="isNextOccurrenceModalOpen = false" class="alert-modal">
  <ng-template>
    <div class="modal-alert-container">
      <div class="modal-alert-header">
        <h3>{{ 'Next occurrence' | translate }}</h3>
      </div>
      <div class="modal-alert-body">
        <p>{{ nextOccurrenceMessage }}</p>
        <div class="duration-row">
          <ion-input type="number" [(ngModel)]="nextOccurrenceDuration" class="duration-input" placeholder="0"></ion-input>
          <ion-select [(ngModel)]="nextOccurrenceUnit" interface="popover" class="unit-select">
            <ion-select-option value="Days">{{ 'Days' | translate }}</ion-select-option>
            <ion-select-option value="Weeks">{{ 'Weeks' | translate }}</ion-select-option>
            <ion-select-option value="Months">{{ 'Months' | translate }}</ion-select-option>
            <ion-select-option value="Years">{{ 'Years' | translate }}</ion-select-option>
          </ion-select>
        </div>
      </div>
      <div class="modal-alert-footer">
        <ion-button fill="clear" (click)="cancelNextOccurrence()">{{ 'No' | translate }}</ion-button>
        <ion-button fill="solid" color="primary" class="bold" (click)="confirmNextOccurrence()" style="--box-shadow: none; --border-radius: 8px;">{{ 'Yes' | translate }}</ion-button>
      </div>
    </div>
  </ng-template>
</ion-modal>